module.exports = __webpack_public_path__ + "static/img/Build_Treatment_Plan_Repository.54744b6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/Build_Treatment_Plan_Repository.jpg
// module id = C6/Y
// module chunks = 0